import React from 'react';
import { ROUTE_NAMES } from '../../../Routes/Routes';
import { ImageList, ImageListItem } from '@material-ui/core';
import ImageButton from '../../../Components/Buttons/ImageButton';
import { CONTRACT_TYPES } from '../../Contracts/contract_enums';
import { REQUEST_TYPE } from '../../PQR/Pqr_enums';

// * ICONS

import InvoiceIconButton from '../../../Components/CustomIcons/IcButtonMyInvoices';
import RevisionButtonIcon from '../../../Components/CustomIcons/RevisionButtonIcon';
import PaymentsIcon from '../../../Components/CustomIcons/PaymentsIcon';
import DuplicatesIconButton from '../../../Components/CustomIcons/IcDuplicatesButton';
import DebtsStatusIcon from '../../../Components/CustomIcons/DebtsStatusIcon';
import OwnershipButton from '../../../Components/CustomIcons/OwnershipIcon';
import SubrogationRequestIcon from '../../../Components/CustomIcons/SubrogationRequestIcon';
import FeeIcon from '../../../Components/CustomIcons/FeeIcon';
import OtherServicesIcon from '../../../Components/CustomIcons/OtherServicesIcon';

const IndustrialOptions = ({
  classes,
  history,
  selectedContract,
  deviceColumns,
  onOpenDuplicates,
  onOpenOtherServices,
  onOpenFees
}) => {
  return (
    <ImageList rowHeight="auto" gap={16} cols={deviceColumns}>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_payments"
          icon={PaymentsIcon}
          title="Pagos"
          aria-label="Pagos"
          onClick={() =>
            history.push(ROUTE_NAMES.payments, {
              type: 'contract',
              value: selectedContract.id
            })
          }
        />
      </ImageListItem>
      {selectedContract.type === CONTRACT_TYPES.Industrial && (
        <ImageListItem classes={{ item: classes.optionTile }}>
          <ImageButton
            id="AuthHome_button_fees"
            icon={FeeIcon}
            title="Tarifas"
            aria-label="Tarifas"
            onClick={onOpenFees}
          />
        </ImageListItem>
      )}
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_invoices"
          icon={InvoiceIconButton}
          title="Mis facturas"
          aria-label="Mis facturas"
          onClick={() => history.push(ROUTE_NAMES.invoices)}
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_duplicates"
          icon={DuplicatesIconButton}
          title="Generar cupón"
          aria-label="genera_un_cupon_de_pago"
          onClick={onOpenDuplicates}
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_periodic_revision"
          icon={RevisionButtonIcon}
          title="Revisión periódica"
          aria-label="Revisión periódica"
          onClick={() => history.push(ROUTE_NAMES.revision)}
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_contribution_exemption"
          icon={SubrogationRequestIcon}
          title="Exención de contribución"
          aria-label="Eximir contribución"
          onClick={() => history.push(ROUTE_NAMES.exemptions)}
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_ownership"
          icon={OwnershipButton}
          title="Cambio de titular"
          aria-label="Cambio de titular"
          onClick={() =>
            history.push(
              `${ROUTE_NAMES.pqr}?type=${REQUEST_TYPE.IndustrialOwnership}`,
              {
                modal: false
              }
            )
          }
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_other_services"
          icon={OtherServicesIcon}
          title="Otros servicios"
          aria-label="Otros servicios"
          onClick={onOpenOtherServices}
        />
      </ImageListItem>
      <ImageListItem classes={{ item: classes.optionTile }}>
        <ImageButton
          id="AuthHome_button_contractStatus"
          icon={DebtsStatusIcon}
          title="Mis deudas"
          aria-label="Mis deudas"
          onClick={() => history.push(ROUTE_NAMES.debtStatus)}
        />
      </ImageListItem>
    </ImageList>
  );
};

export default IndustrialOptions;
